"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable:max-line-length
var CheckoutNetworker_1 = require("./CheckoutNetworker");
var DeliveryInfoResponseMapper_1 = require("../models/mappers/DeliveryInfoResponseMapper");
var CheckoutResponseMapper_1 = require("../models/mappers/CheckoutResponseMapper");
var CheckoutPOSTResponseMapper_1 = require("../models/mappers/CheckoutPOSTResponseMapper");
var PaymentTermsSaveMapper_1 = require("../models/mappers/PaymentTermsSaveMapper");
var YellowPageSearchMapper_1 = require("../models/mappers/YellowPageSearchMapper");
var VoicePanelInfoMapper_1 = require("../models/mappers/VoicePanelInfoMapper");
var EndPointsConfig_1 = require("./EndPointsConfig");
var AddressResponseMapper_1 = require("../models/mappers/AddressResponseMapper");
var CheckoutPOSTResponse_1 = require("../models/responses/CheckoutPOSTResponse");
var ValidateAddressResponseMapper_1 = require("../models/mappers/ValidateAddressResponseMapper");
var PersistAddressResponseMapper_1 = require("../models/mappers/PersistAddressResponseMapper");
var PaymentGetResponseMapper_1 = require("../models/mappers/PaymentGetResponseMapper");
var TermsContentResponseMapper_1 = require("../models/mappers/TermsContentResponseMapper");
var OrderSubmitResponseMapper_1 = require("../models/mappers/OrderSubmitResponseMapper");
var CheckAvailbilityResponseMapper_1 = require("../models/mappers/CheckAvailbilityResponseMapper");
var CreditCheckResponseMapper_1 = require("../models/mappers/CreditCheckResponseMapper");
var ReportingService_1 = require("./ReportingService");
var StateProvider_1 = require("./StateProvider");
var Events_1 = require("./Events");
var LobDataResponseMapper_1 = require("../models/mappers/LobDataResponseMapper");
var ProratedPriceResponseMapper_1 = require("../models/mappers/ProratedPriceResponseMapper");
var ProcessNumberSelectionMapper_1 = require("../models/mappers/ProcessNumberSelectionMapper");
var TermsPanelResponseMapper_1 = require("../models/mappers/TermsPanelResponseMapper");
var DeliveryInfoSaveResponseMapper_1 = require("../models/mappers/DeliveryInfoSaveResponseMapper");
var cms_integration_1 = require("@idp/cms-integration");
var Checkout_cms_1 = require("../cms/Checkout.cms");
var AvailableTimesMapper_1 = require("../models/mappers/AvailableTimesMapper");
var StoreDetailsResponseMapper_1 = require("../models/mappers/StoreDetailsResponseMapper");
var RangeAvailableTimesMapper_1 = require("../models/mappers/RangeAvailableTimesMapper");
var Utils = require("../utils/UtilityFunctions");
var CartUtils = require("../utils/CartUtilFunctions");
var orderUtil = require("../utils/OrderSubmitUtilFunctions");
var InitiatePaypalResponseMapper_1 = require("../models/mappers/InitiatePaypalResponseMapper");
var GetPaypalDetailsResponseMapper_1 = require("../models/mappers/GetPaypalDetailsResponseMapper");
var CheckAvailabilityResponseMapper_1 = require("../models/mappers/CheckAvailabilityResponseMapper");
var TradeInResponseMapper_1 = require("../models/mappers/TradeInResponseMapper");
var localdatastore_1 = require("../config/localdatastore");
var WirelessProductRexRespnseMapper_1 = require("../models/mappers/WirelessProductRexRespnseMapper");
var event_bus_1 = require("@idp/event-bus");
var FeatureResponseMapper_1 = require("../models/mappers/FeatureResponseMapper");
var C2SEvent_1 = require("../components/C2S/C2SEvent");
var CommonUtils = require("../utils/CommonUtilFuntions");
var FeatureService_1 = require("./FeatureService");
var AbpPromotionsMapper_1 = require("../models/mappers/AbpPromotionsMapper");
var CheckoutApi = /** @class */ (function () {
    function CheckoutApi() {
        this.paymentErrorServiceName = 'paymentErrorEvent';
        this.autoPaymentErrorServiceName = 'autoPaymentErrorEvent';
        this.addressErrorServiceName = 'orderPostAddressErrorEvent';
        this.riskAssessmentService = 'riskAssesment';
        this.shippingErrorServiceName = 'shippingErrorEvent';
        this.deliveryErrorServiceName = 'deliveryErrorEvent';
        this.addressRTPValidation = "We couldn't verify the house or box number you provided.\n             Be sure you entered it correctly and try again.";
        this.networker = new CheckoutNetworker_1.default();
        this.reportingService = new ReportingService_1.default();
        this.stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        this.events = new Events_1.default([this.paymentErrorServiceName, this.autoPaymentErrorServiceName,
            this.addressErrorServiceName, this.riskAssessmentService,
            this.shippingErrorServiceName, this.deliveryErrorServiceName]);
        this.apiCsm = cms_integration_1.CMS.get(new Checkout_cms_1.CheckoutCms(), 'CheckoutCms').content.consoleContent;
        this.registerForOrderTermsData = this.registerForOrderTermsData.bind(this);
        this.registerForDeviceTradeInData = this.registerForDeviceTradeInData.bind(this);
        this.registerForOrderTermsData();
        this.registerForDeviceTradeInData();
    }
    CheckoutApi.prototype.getShippingMethods = function (addParam) {
        return this.networker.get(EndPointsConfig_1.default.shippingMethodsMSAPI + (addParam ? addParam : ''), {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            C2SEvent_1.reduxStore.dispatch({ type: 'CLEAR_STORE' });
            return Promise.resolve(new DeliveryInfoResponseMapper_1.DeliveryInfoResponseMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    CheckoutApi.prototype.getAbpPromotions = function (addParam) {
        var _this = this;
        return this.networker.get(EndPointsConfig_1.default.abpPromotions + (addParam ? addParam : ''), {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            _this.stateManager.set('catelogAbpResponse', new AbpPromotionsMapper_1.AbpPromotionsMapper(data)
                .validateCatalogAbpResponse(data));
            return Promise.resolve(new AbpPromotionsMapper_1.AbpPromotionsMapper(data).getFormattedABPPromotions());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    CheckoutApi.prototype.getCreditPanelData = function () {
        return this.networker.get(EndPointsConfig_1.default.creditInfoMSAPI, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new CheckoutResponseMapper_1.CheckoutResponseMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    CheckoutApi.prototype.getCheckout = function () {
        return new CheckoutNetworker_1.default().get(EndPointsConfig_1.default.checkoutMSAPI, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new CheckoutResponseMapper_1.CheckoutResponseMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    CheckoutApi.prototype.getEligibilityResults = function (enableNewEndpoint) {
        if (enableNewEndpoint === void 0) { enableNewEndpoint = false; }
        var apiUrl = EndPointsConfig_1.default.getEligibilityResultsApiUrl;
        if (enableNewEndpoint) {
            apiUrl = EndPointsConfig_1.default.getEligibilityResultsNewApiUrl;
        }
        return this.networker.get(apiUrl, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new LobDataResponseMapper_1.LobDataResponseMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    CheckoutApi.prototype.getPaymentDetails = function () {
        return this.networker.get(EndPointsConfig_1.default.paymentDetailsAPI, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new PaymentGetResponseMapper_1.PaymentGetResponseMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    CheckoutApi.prototype.getConfirmDebtPayment = function () {
        return this.networker.get(EndPointsConfig_1.default.confirmDebtPaymentAPI, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new CreditCheckResponseMapper_1.CreditCheckResponseMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err.error ? err.error : err);
        });
    };
    CheckoutApi.prototype.getAddress = function () {
        return this.networker.get(EndPointsConfig_1.default.addressMSAPI, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new AddressResponseMapper_1.AddressResponseMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    CheckoutApi.prototype.getTermsContent = function (type, losgId, ctn) {
        var url = EndPointsConfig_1.default.termsContentAPI + type;
        if (losgId) {
            url += '&losgId=' + losgId;
        }
        if (ctn) {
            url += '&ctn=' + ctn;
        }
        return this.networker.get(url, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new TermsContentResponseMapper_1.TermsContentResponseMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    CheckoutApi.prototype.getTnCPanelData = function () {
        return this.networker.get(EndPointsConfig_1.default.termsMSAPI, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new TermsPanelResponseMapper_1.TermsPanelResponseMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    /* istanbul ignore next */ // Not Used in current code base
    CheckoutApi.prototype.getPersonalInfo = function () {
        return this.networker.get(EndPointsConfig_1.default.personalInfoAPI, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new CheckoutResponseMapper_1.CheckoutResponseMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    CheckoutApi.prototype.getProratedPrices = function (billCycleDay) {
        var url = EndPointsConfig_1.default.proratedInfoAPI + billCycleDay;
        return this.networker.get(url, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new ProratedPriceResponseMapper_1.ProratedPriceResponseMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    CheckoutApi.prototype.saveAutopayPreferences = function (postData) {
        return this.networker.post(EndPointsConfig_1.default.proratedInfoSaveAPI + '?mode=billCycle', postData, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new CheckoutPOSTResponseMapper_1.CheckoutPOSTResponseMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    CheckoutApi.prototype.postCheckout = function (postData, postType) {
        return this.networker.post(EndPointsConfig_1.default.checkoutPOSTAPI + postType, postData, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new CheckoutPOSTResponseMapper_1.CheckoutPOSTResponseMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    CheckoutApi.prototype.postYellowPageSearch = function (postData) {
        return this.networker.post(EndPointsConfig_1.default.yellowPageSearchAPI, postData, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new YellowPageSearchMapper_1.YellowPageSearchMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    CheckoutApi.prototype.postVoicePanelInfo = function (postData) {
        return this.networker.post(EndPointsConfig_1.default.voicePanelInfo, postData, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new VoicePanelInfoMapper_1.VoicePanelInfoMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    CheckoutApi.prototype.postBillPreference = function (postData) {
        return this.networker.post(EndPointsConfig_1.default.billpreferenceApi, postData, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new CheckoutPOSTResponseMapper_1.CheckoutPOSTResponseMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    CheckoutApi.prototype.postPaymentTermsSelection = function (postData) {
        return this.networker.post(EndPointsConfig_1.default.paymentTermsAPI, postData, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new PaymentTermsSaveMapper_1.PaymentTermsSaveMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    CheckoutApi.prototype.processNumberSelection = function (postData) {
        return this.networker.post(EndPointsConfig_1.default.numberSelectionUrl, postData, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new ProcessNumberSelectionMapper_1.ProcessNumberSelectionMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    CheckoutApi.prototype.getLnpInfoDetails = function () {
        return this.networker.get(EndPointsConfig_1.default.numberSelectionUrl, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new CreditCheckResponseMapper_1.CreditCheckResponseMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err.error ? err.error : err);
        });
    };
    CheckoutApi.prototype.postOrderSubmit = function (applePayData) {
        return __awaiter(this, void 0, void 0, function () {
            var formatedCheckoutData;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.applePayDataForPayment = this.getApplePayData(applePayData);
                        return [4 /*yield*/, this.getFormatedCheckoutResponse(this.applePayDataForPayment).then(function (data) {
                                formatedCheckoutData = data;
                            })];
                    case 1:
                        _a.sent();
                        // Analytics Code: form Submit for checkout submit
                        this.reportingService.fireOrderSubmitUserActionEvent(false, '-2', ReportingService_1.EventTypesCodes.FORM_SUBMIT_EVENT, undefined);
                        return [2 /*return*/, this.networker.post(EndPointsConfig_1.default.checkoutMSAPI, formatedCheckoutData, {
                                headers: Utils.getInitialHeaders(),
                            })
                                .then(function (data) {
                                return _this.processOrderSubmitAPIResponse(data, true);
                            })
                                .catch(function (err) {
                                // Analytics Code: form response for checkout submit
                                _this.reportingService.fireOrderSubmitUserActionEvent(true, err && err.error && err.error.errorId, ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, 'Order submit failed: ' + JSON.stringify(err));
                                _this.logToSplunk({
                                    data: JSON.stringify({
                                        trace: (err && (err.message || err.stack) ?
                                            (err.message + ' | ' + err.stack) : err),
                                    }), hdrReasonCode: 'ORDER_SUBMIT_FAILURE_CATCH_BLOCK', type: 'CTO',
                                });
                                _this.stateManager.set('submitOrderError', { orderSubmitError: true });
                                return Promise.resolve({ error: { errorId: 'System', message: '' } });
                            })];
                }
            });
        });
    };
    // tslint:disable-next-line:no-any
    CheckoutApi.prototype.processOrderSubmitAPIResponse = function (data, isSubmitOrderRequest) {
        var _a, _b, _c, _d, _e, _f;
        if (data && data.content && data.content.response && data.content.response.reportingInfo &&
            data.content.response.reportingInfo.isKonaDeviceAvailable) {
            this.stateManager.set('isKonaDeviceAvailable', { isAvailable: true });
        }
        if (data && data.content && data.content.status && data.content.status.toLowerCase() === 'failure' &&
            data.content.response && data.content.response.riskAssessment &&
            data.content.response.riskAssessment.content && data.content.response.riskAssessment.content.type &&
            (data.content.response.riskAssessment.content.type.toLowerCase() === 'pinvalidationrequired' ||
                data.content.response.riskAssessment.content.type.toLowerCase() === 'authidmitigationrequired') &&
            data.content.response.riskAssessment.content.validationMode && data.content.response.riskAssessment.
            content.validationMode.search('sms_only|email_only|sms_or_email|sms_and_email') > -1) {
            this.reportingService.fireOrderSubmitUserActionEvent(false, (data.content.response.riskAssessment.content.type.toLowerCase() === 'pinvalidationrequired' ||
                data.content.response.riskAssessment.content.type.toLowerCase() === 'authidmitigationrequired') ?
                '-2' : data.content.response.riskAssessment.content.type, ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, data.content.response.riskAssessment.content.validationMode);
            this.events.fireEvent(__assign({}, data), this.riskAssessmentService);
            return Promise.resolve({ error: { errorId: 'inline', message: '' } });
        }
        else if (data && data.content && data.content.status && data.content.status.toLowerCase() === 'failure' &&
            data.content.response && data.content.response.riskAssessment &&
            data.content.response.riskAssessment.content && data.content.response.riskAssessment.content.type &&
            (data.content.response.riskAssessment.content.type.toLowerCase() === 'safeguardvalidationerrors')) {
            this.events.fireEvent(__assign({}, data), this.riskAssessmentService);
            return Promise.resolve({ error: { errorId: 'inline', message: '' } });
        }
        else if (data && data.content && data.content.response && data.content.response.payment
            && (data.content.response.payment.errors ||
                (data.content.response.payment.status
                    && data.content.response.payment.status.toLowerCase() === 'failure'
                    && data.content.response.payment.content.paymentResults
                    && data.content.response.payment.content.paymentResults.duetoday))) {
            this.reportingService.fireOrderSubmitUserActionEvent(false, data.content.response.payment.errors && data.content.response.payment.errors[0]
                && data.content.response.payment.errors[0].errorID, ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, data.content.response.payment.errors && data.content.response.payment.errors[0]
                && data.content.response.payment.errors[0].message);
            this.processPaymentErrors(data.content.response.payment);
            return Promise.resolve({ error: { errorId: 'inline', message: '' } });
        }
        else if (data && data.content
            && data.content.response
            && data.content.response.submitorder
            && data.content.response.submitorder.errors
            && data.content.response.submitorder.errors[0]
            && data.content.response.submitorder.errors[0].errorId === 'SOrder-S-1004') {
            this.reportingService.fireOrderSubmitUserActionEvent(false, data.content.response.submitorder.errors[0].errorId, ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, data.content.response.submitorder.errors[0].message);
            this.redirectToHardStop(CheckoutPOSTResponse_1.CTOMessageType.ORDER_SUBMIT_FAILURE_TYPE_1, JSON.stringify({ trace: data }));
            return Promise.resolve({ error: { errorId: 'inline', message: '' } });
        }
        else if (data && data.content
            && data.content.response
            && data.content.response.submitorder
            && data.content.response.submitorder.errors
            && data.content.response.submitorder.errors[0]
            && data.content.response.submitorder.errors[0].errorId
            && data.content.response.submitorder.errors[0].errorId.toLowerCase() === 'sorder-s-1005') {
            this.redirectToHardStop(CheckoutPOSTResponse_1.CTOMessageType.MAXATTEMPTS, JSON.stringify({ trace: data }));
            return Promise.resolve(data);
        }
        else if (data && data.content && data.content.response && data.content.response.submitorder
            && ((data.content.response.submitorder.errors
                && data.content.response.submitorder.errors[0]
                && data.content.response.submitorder.errors[0].errorId
                && data.content.response.submitorder.errors[0].errorId.toUpperCase().indexOf('PAYMENT') > -1) || (data.content.response.submitorder.status
                && data.content.response.submitorder.status.toLowerCase() === 'failure'
                && data.content.response.submitorder.content.paymentResults
                && data.content.response.submitorder.content.paymentResults.duetoday))) {
            this.reportingService.fireOrderSubmitUserActionEvent(false, data.content.response.submitorder.errors && data.content.response.submitorder.errors[0] &&
                data.content.response.submitorder.errors[0].errorId, ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, data.content.response.submitorder.errors && data.content.response.submitorder.errors[0] &&
                data.content.response.submitorder.errors[0].message);
            this.processPaymentErrors(data.content.response.submitorder);
            return Promise.resolve({ error: { errorId: 'inline', message: '' } });
        }
        else if (data && data.content
            && data.content.response
            && data.content.response.submitorder
            && data.content.response.submitorder.errors
            && data.content.response.submitorder.errors[0]
            && data.content.response.submitorder.errors[0].errorId
            && (data.content.response.submitorder.errors[0].errorId.toLowerCase() === 'sorder-b-c2s' ||
                data.content.response.submitorder.errors[0].errorId.toLowerCase() === 'sorder-b-rti-fm' ||
                data.content.response.submitorder.errors[0].errorId.toLowerCase() === 'sorder-b-hylareturn')) {
            this.reportingService.fireOrderSubmitUserActionEvent(false, data.content.response.submitorder.errors[0].errorId, ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, data.content.response.submitorder.errors[0].message);
            this.processShippingErrors(data.content.response.submitorder);
            return Promise.resolve({ error: { errorId: 'inline', message: '' } });
        }
        else if (data && data.content
            && data.content.response
            && data.content.response.submitorder
            && data.content.response.submitorder.errors
            && data.content.response.submitorder.errors[0]
            && data.content.response.submitorder.errors[0].errorId
            && data.content.response.submitorder.errors[0].errorId.toLowerCase() === 'sorder-b-rti-oo') {
            this.reportingService.fireOrderSubmitUserActionEvent(false, data.content.response.submitorder.errors[0].errorId, ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, data.content.response.submitorder.errors[0].message);
            this.redirectToHardStop(CheckoutPOSTResponse_1.CTOMessageType.SHIPPING_FAILURE_OUT_OF_STOCK, JSON.stringify({ trace: data }));
            return Promise.resolve({ error: { errorId: 'inline', message: '' } });
        }
        else if (data && data.content
            && data.content.response
            && data.content.response.submitorder
            && data.content.response.submitorder.errors
            && data.content.response.submitorder.errors[0]
            && data.content.response.submitorder.errors[0].errorId
            && data.content.response.submitorder.errors[0].errorId.toLowerCase() === 'sorder-b-rti-ins') {
            this.reportingService.fireOrderSubmitUserActionEvent(false, data.content.response.submitorder.errors[0].errorId, ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, data.content.response.submitorder.errors[0].message);
            this.redirectToHardStop(CheckoutPOSTResponse_1.CTOMessageType.SHIPPING_FAILURE_INSUFFICIENT_INVENTORY, JSON.stringify({ trace: data }));
            return Promise.resolve({ error: { errorId: 'inline', message: '' } });
        }
        else if (data && data.content
            && data.content.response
            && data.content.response.submitorder
            && data.content.response.submitorder.errors
            && data.content.response.submitorder.errors[0]
            && data.content.response.submitorder.errors[0].errorId
            && data.content.response.submitorder.errors[0].errorId.toLowerCase() === 'shipping-s-1005') {
            this.reportingService.fireOrderSubmitUserActionEvent(false, data.content.response.submitorder.errors[0].errorId, ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, data.content.response.submitorder.errors[0].message);
            this.processShippingErrors(data.content.response.submitorder);
            return Promise.resolve({ error: { errorId: 'inline', message: '' } });
        }
        else if (data && data.content && data.content.errors && data.content.errors[0]) {
            if (isSubmitOrderRequest) {
                this.reportingService.fireOrderSubmitUserActionEvent(true, data.content.errors[0].errorId, ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, data.content.errors[0].errorId + ': ' +
                    data.content.errors[0].message);
            }
            switch (data.content.errors[0].errorId && data.content.errors[0].errorId.toLowerCase()) {
                case 'sorder-ra-1002':
                    this.redirectToHardStop(CheckoutPOSTResponse_1.CTOMessageType.GFMO, JSON.stringify({ trace: data }));
                    break;
                case 'sorder-ra-1003':
                case 'fraudcheck-s-1003':
                    this.redirectToHardStop(CheckoutPOSTResponse_1.CTOMessageType.RETAIL, JSON.stringify({ trace: data }));
                    break;
                case 'fraudcheck-u-1006':
                case 'sorder-s-1005':
                    this.redirectToHardStop(CheckoutPOSTResponse_1.CTOMessageType.MAXATTEMPTS, JSON.stringify({ trace: data }));
                    return Promise.resolve(data);
                case 'fraudcheck-u-1004':
                case 'fraudcheck-s-1002':
                case 'sim-cto':
                    return Promise.resolve({ error: { errorId: data.content.errors[0].errorId, message: '' } });
                case 'sim-1013':
                case 'sim-1014':
                    this.redirectToHardStop(CheckoutPOSTResponse_1.CTOMessageType.SIM_SWAP_ERROR, JSON.stringify({ trace: data }));
                    break;
                case 'sorder-ra-1004':
                case 'sorder-ra-1005':
                    this.events.fireEvent(__assign({}, data), this.riskAssessmentService);
                    break;
                case 'service-i-1020':
                    this.redirectToHardStop(CheckoutPOSTResponse_1.CTOMessageType.ORDER_SUBMIT_FAILURE_TYPE_2, JSON.stringify({ trace: data }));
                    return Promise.resolve(data);
                default:
                    this.redirectToHardStop(data.content.errors[0].errorId, JSON.stringify({ trace: data }));
                    break;
            }
            return Promise.resolve({ error: { errorId: 'inline', message: '' } });
        }
        else if (data && data.content
            && data.content.response
            && data.content.response.submitorder
            && data.content.response.submitorder.errors) {
            var errorID = data.content.response.submitorder.errors && data.content.response.submitorder.errors[0];
            if (isSubmitOrderRequest) {
                this.reportingService.fireOrderSubmitUserActionEvent(true, errorID && errorID.errorId, ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, errorID && errorID.errorId + ': ' +
                    errorID && errorID.message);
            }
            this.logToSplunk({
                data: JSON.stringify({ trace: (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.content) === null || _a === void 0 ? void 0 : _a.response) === null || _b === void 0 ? void 0 : _b.submitorder) === null || _c === void 0 ? void 0 : _c.errors }),
                hdrReasonCode: 'ORDER_SUBMIT_FAILURE_' + (errorID && errorID.errorId), type: 'CTO',
            });
            this.stateManager.set('submitOrderError', { orderSubmitError: true });
            return Promise.resolve({ error: { errorId: isSubmitOrderRequest ? 'System' :
                        errorID && errorID.errorId, message: '' } });
        }
        else if (data && data.content
            && data.content.response
            && data.content.response.submitorder
            && data.content.response.submitorder.status
            && data.content.response.submitorder.status.toLowerCase() === 'failure') {
            return this.processRealTimeProcessErrors(data.content.response.submitorder.content, isSubmitOrderRequest);
        }
        else if (data && data.content
            && data.content.response
            && data.content.response.submitorder
            && data.content.response.submitorder.content
            && data.content.response.submitorder.content.order
            && ((data.content.response.submitorder.status
                && data.content.response.submitorder.status.toLowerCase() === 'success') ||
                (data.content.response.submitorder.content.order.transactionStatus.toLowerCase() === 'success'))) {
            // Analytics Code: form response for checkout submit and order confirm
            if (isSubmitOrderRequest) {
                this.reportingService.fireOrderSubmitUserActionEvent(false, '0', ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, undefined);
            }
            this.stateManager.remove('DevicePPUAddress');
            this.stateManager.set('orderConfirmationData', data.content.response.submitorder.content);
            this.stateManager.set('orderSubmitURL', orderUtil.contrsuctOrderConfirmURL(data.content.response.submitorder.content.order));
            return Promise.resolve(new OrderSubmitResponseMapper_1.OrderSubmitResponseMapper(data.content.response.submitorder)
                .getDataObject());
        }
        else {
            if (isSubmitOrderRequest) {
                this.reportingService.fireOrderSubmitUserActionEvent(true, undefined, ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, 'error in submit order');
            }
            this.logToSplunk({
                data: JSON.stringify({ trace: (_f = (_e = (_d = data === null || data === void 0 ? void 0 : data.content) === null || _d === void 0 ? void 0 : _d.response) === null || _e === void 0 ? void 0 : _e.submitorder) === null || _f === void 0 ? void 0 : _f.errors }),
                hdrReasonCode: 'ORDER_SUBMIT_FAILURE_RESPONSE_STATUS_FAILURE', type: 'CTO',
            });
            this.stateManager.set('submitOrderError', { orderSubmitError: true });
            return Promise.resolve({ error: { errorId: isSubmitOrderRequest ? 'System' :
                        'RESPONSE_STATUS_FAILURE', message: '' } });
        }
    };
    CheckoutApi.prototype.getErrorListFromLOSG = function (orderContent) {
        var errorList;
        if (orderContent && orderContent.order && orderContent.order.dtvnowCart
            && orderContent.order.dtvnowCart.losgs) {
            var losgKeys = Object.keys(orderContent.order.dtvnowCart.losgs);
            var errorLOSG = orderContent.order.dtvnowCart.losgs[losgKeys[0]];
            if (errorLOSG && errorLOSG.losgStatus && errorLOSG.losgStatus.fallout) {
                errorList = errorLOSG.losgStatus.fallout;
            }
        }
        return errorList;
    };
    CheckoutApi.prototype.redirectToHardStop = function (ctoType, data) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var cartcheckoutCms = cms_integration_1.CMS.get(new Checkout_cms_1.CheckoutCms(), 'cartcheckout').content;
        var creditCms = (_a = cartcheckoutCms === null || cartcheckoutCms === void 0 ? void 0 : cartcheckoutCms.creditVerificationPanel) === null || _a === void 0 ? void 0 : _a.panelContent;
        var signatureSubmitError = ((_b = cartcheckoutCms === null || cartcheckoutCms === void 0 ? void 0 : cartcheckoutCms.checkoutCTOModal) === null || _b === void 0 ? void 0 : _b.newSignatureSubmitError) ||
            "We hit a snag and you'll need to go back to your cart. Once there, select <strong>Check out</strong>\n         to restart the checkout process. We're sorry for the inconvenience, but this should fix the problem.";
        this.stateManager.remove('DevicePPUAddress');
        switch (ctoType) {
            case CheckoutPOSTResponse_1.CTOMessageType.GFMO:
                this.stateManager.set('hardStop', {
                    data: data,
                    hardStopperText: CommonUtils.getHardStopText((_c = this.apiCsm) === null || _c === void 0 ? void 0 : _c.hardStopGMFOLabel),
                    reasonCode: ctoType,
                });
                break;
            case CheckoutPOSTResponse_1.CTOMessageType.RETAIL:
                this.stateManager.set('hardStop', {
                    data: data,
                    hardStopperText: this.apiCsm.hardStopRetailStoreLabel,
                    reasonCode: ctoType,
                });
                break;
            case CheckoutPOSTResponse_1.CTOMessageType.OTHERS:
            case CheckoutPOSTResponse_1.CTOMessageType.ORDER_SUBMIT_FAILURE_TYPE_1:
            case CheckoutPOSTResponse_1.CTOMessageType.PAYMENT_FAILURE:
                if (Utils.IsStandaloneDTVNOWInCart()) {
                    this.stateManager.set('hardStop', {
                        data: data,
                        hardStopperText: this.apiCsm.hardStopforStandAloneDTVN,
                        reasonCode: ctoType,
                    });
                }
                else {
                    this.stateManager.set('hardStop', {
                        data: data,
                        hardStopperText: ((Utils.isSMBNewCustomerFlow()) ?
                            CommonUtils.getHardStopText(creditCms === null || creditCms === void 0 ? void 0 : creditCms.smbDebtHardStop) :
                            CommonUtils.getHardStopText((_d = this.apiCsm) === null || _d === void 0 ? void 0 : _d.hardStopforAllNonDTVN)),
                        reasonCode: ctoType,
                    });
                }
                break;
            case CheckoutPOSTResponse_1.CTOMessageType.MAXATTEMPTS:
            case CheckoutPOSTResponse_1.CTOMessageType.SIM_SWAP_ERROR:
                var cmsData = cms_integration_1.CMS.get(new Checkout_cms_1.CheckoutCms(), 'CheckoutCms').content.orderSubmit2FAModel;
                var ctoMsg = (ctoType === CheckoutPOSTResponse_1.CTOMessageType.SIM_SWAP_ERROR ? cmsData.simSwapErrorMessage :
                    Utils.isSMBNewCustomerFlow() ?
                        CommonUtils.getHardStopText(creditCms === null || creditCms === void 0 ? void 0 : creditCms.smbDebtHardStop) :
                        (Utils.isSMBBBCustomerFlow() ?
                            CommonUtils.getHardStopText(creditCms === null || creditCms === void 0 ? void 0 : creditCms.smbWirelineBBHardStopText)
                            : CommonUtils.getHardStopText(cmsData === null || cmsData === void 0 ? void 0 : cmsData.hardStopCTOMsg)));
                this.stateManager.set('hardStop', {
                    data: data,
                    hardStopperText: ctoMsg,
                    reasonCode: ctoType,
                });
                break;
            case CheckoutPOSTResponse_1.CTOMessageType.SHIPPING_FAILURE_OUT_OF_STOCK:
            case CheckoutPOSTResponse_1.CTOMessageType.SHIPPING_FAILURE_INSUFFICIENT_INVENTORY:
                this.stateManager.set('cartRedirect', {
                    data: data,
                    reasonCode: ctoType,
                });
                break;
            case CheckoutPOSTResponse_1.CTOMessageType.ORDER_SUBMIT_FAILURE_TYPE_2:
                this.stateManager.set('hardStop', {
                    data: data,
                    hardStopperText: signatureSubmitError,
                    reasonCode: ctoType,
                    ctaText: (_e = cartcheckoutCms === null || cartcheckoutCms === void 0 ? void 0 : cartcheckoutCms.checkoutCTOModal) === null || _e === void 0 ? void 0 : _e.submitCTALabel,
                    hardStopTitle: (_f = cartcheckoutCms === null || cartcheckoutCms === void 0 ? void 0 : cartcheckoutCms.checkoutCTOModal) === null || _f === void 0 ? void 0 : _f.rtiBillPreferenceTitleLabel,
                });
                break;
            case CheckoutPOSTResponse_1.CTOMessageType.BILL_PREFERENCE_POST_ERROR:
                var cms = cms_integration_1.CMS.get(new Checkout_cms_1.CheckoutCms(), 'CheckoutCms').content.orderSubmit2FAModel;
                this.stateManager.set('hardStop', {
                    data: data,
                    hardStopperText: (_g = this.apiCsm) === null || _g === void 0 ? void 0 : _g.hardStopforAllNonDTVN,
                    reasonCode: ctoType,
                });
                break;
            default:
                this.stateManager.set('hardStop', {
                    data: data,
                    hardStopperText: CommonUtils.getHardStopText((_h = this.apiCsm) === null || _h === void 0 ? void 0 : _h.hardStopforAllNonDTVN),
                    reasonCode: ctoType,
                });
                break;
        }
    };
    CheckoutApi.prototype.getFormatedCheckoutResponse = function (applePayData) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var showNewTyPage, featureService, vanityCode, leadId, parseSS, req, andiChat, chatDetails;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        showNewTyPage = Utils.purchaseorderThankyouRedirection();
                        featureService = FeatureService_1.default.getInstance();
                        try {
                            parseSS = featureService.getFeatureStatus(FeatureService_1.FeatureNames.ENABLE_VANITYCODE_AND_LEADID) ? orderUtil.getVanityCodeAndLeadId() : {};
                            vanityCode = parseSS === null || parseSS === void 0 ? void 0 : parseSS.vanityCode;
                            leadId = parseSS === null || parseSS === void 0 ? void 0 : parseSS.leadId;
                        }
                        catch (e) {
                            console.error('Error while getting vanity code and lead id', e);
                        }
                        req = {
                            payload: {
                                submitorder: {
                                    browserid: 'A002487027289',
                                    flowcode: this.getFlowCode(),
                                    isFirstNet: CartUtils.isFirstNetCustomer(),
                                    mid: this.getAdobeMIDValue(document.cookie),
                                    thankyoupageurl: showNewTyPage ? '/buy/purchaseorder/thankyou' : '/buy/thankyou',
                                },
                            },
                        };
                        if (vanityCode && leadId) {
                            req.payload.submitorder.vanityCode = vanityCode;
                            req.payload.submitorder.leadId = leadId;
                        }
                        andiChat = featureService.getFeatureStatus(FeatureService_1.FeatureNames.ANDI_CHAT) || false;
                        return [4 /*yield*/, CommonUtils.getChatDetails(andiChat)];
                    case 1:
                        chatDetails = _b.sent();
                        if (this.orderTermstData) {
                            (_a = this.orderTermstData) === null || _a === void 0 ? void 0 : _a.forEach(function (terms, index) {
                                terms.accepted = true;
                            });
                            req.payload.term = {
                                eligibleOrderTerms: this.orderTermstData,
                            };
                        }
                        if (this.deviceTradeInData) {
                            req.payload.tradeInConsent = {
                                tradeInConsent: this.deviceTradeInData,
                            };
                        }
                        if (applePayData) {
                            req.payload.submitorder.applePay = applePayData;
                        }
                        if ((chatDetails === null || chatDetails === void 0 ? void 0 : chatDetails.aid) && ((chatDetails === null || chatDetails === void 0 ? void 0 : chatDetails.aid.indexOf('virtualAssistant')) === -1) && (chatDetails === null || chatDetails === void 0 ? void 0 : chatDetails.id)) {
                            req.payload.submitorder.chatagentid = chatDetails === null || chatDetails === void 0 ? void 0 : chatDetails.aid;
                            req.payload.submitorder.chatid = chatDetails === null || chatDetails === void 0 ? void 0 : chatDetails.id;
                        }
                        return [2 /*return*/, req];
                }
            });
        });
    };
    CheckoutApi.prototype.getAdobeMIDValue = function (browserCookie) {
        var mcmidvalue = '';
        if (browserCookie && browserCookie.length > 0 && browserCookie.indexOf('%7CMCMID%7C') > 0) {
            var splitMIDValue = browserCookie.substring(browserCookie.indexOf('%7CMCMID%7C') + 11, browserCookie.length + 1);
            mcmidvalue = splitMIDValue.substring(0, splitMIDValue.indexOf('%7C'));
        }
        return mcmidvalue;
    };
    CheckoutApi.prototype.getFlowCode = function () {
        var analyticsObj = this.reportingService.getFlowCodeAndproductType();
        return analyticsObj && analyticsObj['page.pageInfo.flowCode'];
    };
    // tslint:disable-next-line:no-any
    CheckoutApi.prototype.isEmptyObject = function (obj) {
        for (var prop in obj) {
            if (obj.hasOwnProperty(prop)) {
                return false;
            }
        }
        return true;
    };
    // tslint:disable-next-line:no-any
    CheckoutApi.prototype.processPaymentErrors = function (payError) {
        var paymentCms = cms_integration_1.CMS.get(new Checkout_cms_1.CheckoutCms(), 'cartcheckout').content.dueTodayPanel.paymentForm;
        var errorCode = '';
        var paymentError = Object.assign({}, payError);
        if (paymentError && paymentError.errors && paymentError.errors[0] && paymentError.errors[0].errorId) {
            errorCode = paymentError.errors[0].errorId;
        }
        if (errorCode === 'Payment-B-1000') {
            this.redirectToHardStop(CheckoutPOSTResponse_1.CTOMessageType.PAYMENT_FAILURE, JSON.stringify({ trace: payError }));
        }
        else if (errorCode === 'Payment-B-1001') {
            paymentError.errors[0].message = this.apiCsm.paymentRTPValidation;
            this.events.fireEvent(paymentError, this.paymentErrorServiceName);
        }
        else if (errorCode === 'Payment-BTM-1001') {
            paymentError.errors[0].message = this.apiCsm.btmLimit;
            this.events.fireEvent(paymentError, this.paymentErrorServiceName);
        }
        else if (errorCode === 'Payment-A-1001') {
            paymentError.errors[0].message = (paymentCms === null || paymentCms === void 0 ? void 0 : paymentCms.snagApplePayMessage) || this.apiCsm.snagApplePayMessage;
            this.events.fireEvent(paymentError, this.paymentErrorServiceName);
        }
        else if (errorCode === 'Payment-B-1001_AUTOPAY') {
            this.events.fireEvent({
                errorId: errorCode,
                message: this.apiCsm.paymentRTPValidation,
            }, this.autoPaymentErrorServiceName);
        }
        else if (errorCode && errorCode.indexOf('AUTOPAY') > -1) {
            this.events.fireEvent(paymentError.errors[0], this.autoPaymentErrorServiceName);
        }
        else {
            this.events.fireEvent(paymentError, this.paymentErrorServiceName);
        }
    };
    // tslint:disable-next-line:no-any
    CheckoutApi.prototype.processShippingErrors = function (submitError) {
        var errorCode = '';
        var shippingError = Object.assign({}, submitError);
        if (shippingError && shippingError.errors && shippingError.errors[0].errorId) {
            errorCode = shippingError.errors[0].errorId;
        }
        if (errorCode === 'SOrder-B-C2S' || (errorCode === null || errorCode === void 0 ? void 0 : errorCode.toLowerCase()) === 'sorder-b-rti-fm' ||
            (errorCode === null || errorCode === void 0 ? void 0 : errorCode.toLowerCase()) === 'sorder-b-hylareturn') {
            /* Take user back to delivery panel and display error message with latest shippinginfo cal*/
            this.events.fireEvent(shippingError, this.shippingErrorServiceName);
        }
        else if (errorCode === 'Shipping-S-1005') {
            this.events.fireEvent(shippingError, this.deliveryErrorServiceName);
        }
        else {
            // Do nothing
        }
    };
    // tslint:disable-next-line:no-any
    CheckoutApi.prototype.processRealTimeProcessErrors = function (submitorderCotent, isSubmitOrderRequest) {
        var _a;
        var errorDetails = this.getErrorListFromLOSG(submitorderCotent);
        var lastIndex = -1;
        this.reportingService.fireOrderSubmitUserActionEvent(true, errorDetails && errorDetails.code, ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, 'processRealTimeProcessErrors: ' + JSON.stringify(submitorderCotent));
        if (errorDetails && errorDetails.code &&
            EndPointsConfig_1.default.realtimePaymentErrors.some(function (err, index) {
                lastIndex = index;
                return errorDetails.code.includes(err);
            })) {
            var paymentError = {
                errorId: EndPointsConfig_1.default.realtimePaymentErrors[lastIndex],
                message: (errorDetails.code === 'eV1385' ?
                    this.apiCsm.paymentRTPValidation : this.apiCsm.prepaidCardRTPValidation),
            };
            this.events.fireEvent(paymentError, this.paymentErrorServiceName);
            return Promise.resolve({ error: { errorId: 'inline', message: '' } });
        }
        else if (errorDetails && errorDetails.code &&
            EndPointsConfig_1.default.realtimeBillingErrors.indexOf(errorDetails.code) > -1) {
            var addressError = {
                errorId: errorDetails.code,
                message: this.addressRTPValidation,
            };
            this.events.fireEvent(addressError, this.addressErrorServiceName);
            return Promise.resolve({ error: { errorId: 'inline', message: '' } });
        }
        else if (errorDetails && errorDetails.code && errorDetails.code !== '') {
            this.redirectToHardStop(CheckoutPOSTResponse_1.CTOMessageType.OTHERS, JSON.stringify({ trace: submitorderCotent }));
            return Promise.resolve({ error: { errorId: 'inline', message: '' } });
        }
        else {
            this.logToSplunk({
                data: JSON.stringify({ trace: (_a = submitorderCotent === null || submitorderCotent === void 0 ? void 0 : submitorderCotent.order) === null || _a === void 0 ? void 0 : _a.transactionStatus }),
                hdrReasonCode: 'ORDER_SUBMIT_FAILURE_' + (errorDetails && errorDetails.code), type: 'CTO',
            });
            this.stateManager.set('submitOrderError', { orderSubmitError: true });
            return Promise.resolve({ error: { errorId: isSubmitOrderRequest ? 'System' :
                        (errorDetails && errorDetails.code), message: '' } });
        }
    };
    CheckoutApi.prototype.validateAddress = function (addressPostData) {
        return this.networker.post(EndPointsConfig_1.default.validateAddressMSAPI, addressPostData, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new ValidateAddressResponseMapper_1.ValidateAddressResponseMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    CheckoutApi.prototype.validateFirstAvaibilityAddressFeilds = function (addressPostData) {
        return this.networker.post(EndPointsConfig_1.default.validateAddress, addressPostData, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new ValidateAddressResponseMapper_1.ValidateAddressResponseMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    CheckoutApi.prototype.persistAddress = function (persistAddressData) {
        return this.networker.post(EndPointsConfig_1.default.checkoutPOSTAPI + 'address', persistAddressData, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new PersistAddressResponseMapper_1.PersistAddressResponseMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    CheckoutApi.prototype.checkAvailbilityRequest = function (userID) {
        var bodyoBJ = { userId: userID };
        return this.networker.post(EndPointsConfig_1.default.checkAvailability, bodyoBJ, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new CheckAvailbilityResponseMapper_1.CheckAvailbilityResponseMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    CheckoutApi.prototype.runCreditCheck = function (creditCheckPostData) {
        return this.networker.post(EndPointsConfig_1.default.initiateCreditCheck, creditCheckPostData, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new CreditCheckResponseMapper_1.CreditCheckResponseMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err.error ? err.error : err);
        });
    };
    CheckoutApi.prototype.runSafeScanCreditCheck = function (safeScanPostData) {
        return this.networker.post(EndPointsConfig_1.default.creditSafeScan, safeScanPostData, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new CreditCheckResponseMapper_1.CreditCheckResponseMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err.error ? err.error : err);
        });
    };
    CheckoutApi.prototype.continueCreditPolicy = function (continueCreditPolicyPostData) {
        return this.networker.post(EndPointsConfig_1.default.continueCreditPolicy, continueCreditPolicyPostData, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new CreditCheckResponseMapper_1.CreditCheckResponseMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err.error ? err.error : err);
        });
    };
    CheckoutApi.prototype.payDebt = function (request) {
        return this.networker.post(EndPointsConfig_1.default.debtPayment, request, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new CreditCheckResponseMapper_1.CreditCheckResponseMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err.error ? err.error : err);
        });
    };
    CheckoutApi.prototype.saveShippingMethod = function (request) {
        return this.networker.post(EndPointsConfig_1.default.shippingMSAPI, request, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new DeliveryInfoSaveResponseMapper_1.DeliveryInfoSaveResponseMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    CheckoutApi.prototype.getAvailableTimes = function (request) {
        return this.networker.post(EndPointsConfig_1.default.deliveryInfoAvailableTimesMSAPI, request, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new AvailableTimesMapper_1.AvailableTimesMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    CheckoutApi.prototype.getStoreDetails = function (storeId) {
        return this.networker.get(EndPointsConfig_1.default.storeDetails + storeId, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new StoreDetailsResponseMapper_1.StoreDetailsResponseMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    CheckoutApi.prototype.getRangeOfAvailableTimes = function (request) {
        return this.networker.post(EndPointsConfig_1.default.deliveryInfoAvailableTimesMSAPI, request, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new RangeAvailableTimesMapper_1.RangeAvailableTimesMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    CheckoutApi.prototype.getSchedulingInfo = function () {
        return this.networker.get(EndPointsConfig_1.default.schedulingInfoMSAPI, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new CheckoutResponseMapper_1.CheckoutResponseMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    CheckoutApi.prototype.getFeatures = function () {
        return this.networker.get(EndPointsConfig_1.default.featureAPI, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new FeatureResponseMapper_1.FeatureResponseMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    CheckoutApi.prototype.getPaypalToken = function (request) {
        return this.networker.post(EndPointsConfig_1.default.initiatePaypal, request, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new InitiatePaypalResponseMapper_1.InitiatePaypalResponseMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    CheckoutApi.prototype.getPaypalDetails = function (request) {
        return this.networker.post(EndPointsConfig_1.default.getPayPalDetails, request, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new GetPaypalDetailsResponseMapper_1.GetPaypalDetailsResponseMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    CheckoutApi.prototype.checkAvailability = function (postData) {
        return this.networker.post(EndPointsConfig_1.default.ckavapiurl, postData, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new CheckAvailabilityResponseMapper_1.CheckAvailabilityResponseMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    CheckoutApi.prototype.getCkavStorageData = function () {
        var ckavContent = this.stateManager.get(localdatastore_1.getNamespace('CHECKOUT'), 'ckav');
        return __assign(__assign({}, ckavContent), { isPerformed: !!(ckavContent) });
    };
    CheckoutApi.prototype.getCkavCheckoutStorageData = function () {
        return this.stateManager.get(localdatastore_1.getNamespace('CHECKOUT'), 'ckavCheckout');
    };
    CheckoutApi.prototype.fraudActionSendPin = function (request) {
        return this.networker.post(EndPointsConfig_1.default.fraudCheckSendPin, request, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new CheckoutResponseMapper_1.CheckoutResponseMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    CheckoutApi.prototype.fraudvalidatePin = function (inComingReq) {
        return __awaiter(this, void 0, void 0, function () {
            var request;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.applePayDataForPayment = this.getApplePayData();
                        return [4 /*yield*/, this.getFormatedCheckoutResponse(this.applePayDataForPayment).then(function (data) {
                                request = data;
                            })];
                    case 1:
                        _a.sent();
                        if (inComingReq && inComingReq.action) {
                            request.payload.riskAssessment = inComingReq;
                        }
                        return [2 /*return*/, this.networker.post(EndPointsConfig_1.default.checkoutPOSTAPI + 'riskAssessment', request, {
                                headers: Utils.getInitialHeaders(),
                            })
                                .then(function (data) {
                                return _this.processOrderSubmitAPIResponse(data, false);
                            })
                                .catch(function (err) {
                                return Promise.reject(err);
                            })];
                }
            });
        });
    };
    CheckoutApi.prototype.getTradeInInfo = function () {
        return this.networker.get(EndPointsConfig_1.default.tradeInApiUrl, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new TradeInResponseMapper_1.TradeInResponseMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    CheckoutApi.prototype.postTradeDetails = function (req) {
        return this.networker.post(EndPointsConfig_1.default.tradeInApiUrl + '/consent', req, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new CheckoutPOSTResponseMapper_1.CheckoutPOSTResponseMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    /* istanbul ignore next */ // Disabling coverage as method is not used as part of the code base
    // tslint:disable-next-line:no-any
    CheckoutApi.prototype.postEdsEncriptionForActivation = function (req) {
        return this.networker.post(EndPointsConfig_1.default.edsEncryptionForActivation, req, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(data);
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    /* istanbul ignore next */ // Disabling coverage as method is not used as part of the code base
    // tslint:disable-next-line:no-any
    CheckoutApi.prototype.postEdsEncriptionForActivationEAP = function (req) {
        return this.networker.post(EndPointsConfig_1.default.EapEdsEncryptionForActivation, req, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(data);
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    CheckoutApi.prototype.getWirelessProductRex = function (deviceSkus, planSku) {
        return this.networker.get(EndPointsConfig_1.default.wirelessProductRexMSAPI + "?deviceSkus=" + deviceSkus + "&planSku=" + planSku, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new WirelessProductRexRespnseMapper_1.WirelessProductRexRespnseMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    CheckoutApi.prototype.getConfirmSecurityFee = function () {
        return this.networker.get(EndPointsConfig_1.default.confirmSecurityFeeAPI, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new CreditCheckResponseMapper_1.CreditCheckResponseMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err.error ? err.error : err);
        });
    };
    CheckoutApi.prototype.logToSplunk = function (data) {
        // do not worry about the response, whatever data needed just send the data and forget.
        // do not log anything from the response on the console for security reasons.
        var hdrs = Utils.getInitialHeaders();
        hdrs.append('idp-reasonCode', data.hdrReasonCode ? data.hdrReasonCode : 'UNKNOWN');
        hdrs.append('idp-logType', data.type);
        var errors = [];
        errors.push(data.data);
        this.networker.post(EndPointsConfig_1.default.loggingMSAPI, { messages: errors }, {
            headers: hdrs,
        })
            .then(function () {
            // console.log('logged error to splunk');
        })
            .catch(function () {
            // console.error('could not send error to Splunk', error);
        });
    };
    /* istanbul ignore next */ // Disabling coverage as method is added for test purposes
    CheckoutApi.prototype.logDataToElk = function (logCode, logMsg, logStack, pageUrl) {
        var _a;
        if (logCode === void 0) { logCode = ''; }
        if (logMsg === void 0) { logMsg = ''; }
        if (logStack === void 0) { logStack = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var LOG_URL;
            return __generator(this, function (_b) {
                LOG_URL = '/buy/shoppingcart/log-error/';
                try {
                    fetch(LOG_URL, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            logCode: logCode,
                            logMsg: logMsg,
                            logStack: logStack,
                            pageUrl: pageUrl || ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.href),
                        }),
                    });
                }
                catch (error) {
                    console.log(error);
                }
                return [2 /*return*/];
            });
        });
    };
    /* istanbul ignore next */
    CheckoutApi.prototype.populateSkuToCMSMapping = function () {
        var _this = this;
        return this.networker.get(EndPointsConfig_1.default.deviceSKUMapping, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (response) { return response; })
            .catch(function (response) {
            return _this.networker.get(EndPointsConfig_1.default.deviceSKUMapping, {
                headers: Utils.getInitialHeaders(),
            })
                .catch(function (r) {
                return Promise.resolve(require('../config/mock_data/devices.skumapping.js.json'));
            });
        });
    };
    CheckoutApi.prototype.cartRepriceForACP = function (repriceCartReq) {
        return this.networker.post(EndPointsConfig_1.default.cartRepriceAPI, repriceCartReq, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(data);
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    CheckoutApi.prototype.getApplePayData = function (applePayData) {
        var applePayDataFromSession = sessionStorage.getItem('CHECKOUT:applePayData') &&
            JSON.parse(sessionStorage.getItem('CHECKOUT:applePayData'));
        return applePayData || applePayDataFromSession || null;
    };
    CheckoutApi.prototype.registerForOrderTermsData = function () {
        var _this = this;
        var dutodayPaymentObserver = {
            eventHandler: function (data) {
                if (!_this.orderTermstData) {
                    _this.orderTermstData = data;
                }
            },
            observerId: event_bus_1.ICCEventBusManager.getUUID(),
            serviceName: 'orderTermsUpdate',
        };
        event_bus_1.ICCEventBusManager.getInstance().registerObserver(dutodayPaymentObserver);
    };
    CheckoutApi.prototype.registerForDeviceTradeInData = function () {
        var _this = this;
        var dutodayPaymentObserver = {
            eventHandler: function (data) {
                if (!_this.deviceTradeInData) {
                    _this.deviceTradeInData = data;
                }
            },
            observerId: event_bus_1.ICCEventBusManager.getUUID(),
            serviceName: 'deviceTradeIn',
        };
        event_bus_1.ICCEventBusManager.getInstance().registerObserver(dutodayPaymentObserver);
    };
    return CheckoutApi;
}());
exports.default = CheckoutApi;
//# sourceMappingURL=CheckoutApi.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/api/CheckoutApi.js
// module id = 455
// module chunks = 8